import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { arbitrators } from '../../store/actions';

const styles = theme => ({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    paper: {
      width: '80%',
      maxHeight: 435,
    },
  });



class ChooseArbitratorDialogInCaseInformation extends Component {
  state = {
    //open: false
    lang: localStorage.getItem('language')
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = (value) => {
    this.props.toggleOpen();
    if(value === 'Upload_Yes'){
        this.props.setArbitrators();
    }
    else  if(value === 'Upload_No'){
      this.props.unSelect();
    }
    //this.setState({ open: false });
  };

  render() {
    let userType = '';
    if(this.props.claimantUniqueId == this.props.uniqueId){
        userType = 'claimant';
    }else if(this.props.respondentUniqueId == this.props.uniqueId){
        userType = 'respondent';
    }
    var separator=''
    if (this.state.lang == 'en'){
      separator=' '
    }
    else{
      separator=''
    }

    var arbitratorFirstName = ''
    var arbitratorLastName = ''
    for  (var i=0;i<this.props.arbitrators.length; i++){
      if (this.props.arbitrators[i].arbitratorId == this.props.arbitratorId){
        arbitratorFirstName = this.props.arbitrators[i].firstname
        arbitratorLastName = this.props.arbitrators[i].lastname
      }
    }
    // console.log('chooseArbitratorDialog this.props.claimantUniqueId: '+this.props.claimantUniqueId)
    // console.log('chooseArbitratorDialog this.props.respondentUniqueId: '+this.props.respondentUniqueId)
    // console.log('chooseArbitratorDialog this.props.uniqueId: '+this.props.uniqueId)
    // console.log('chooseArbitratorDialog is it respondent: '+userType)

      return (
        <div>
          <Dialog
            disableBackdropClick
            maxWidth= 'sm'
            open={this.props.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description" >
            <DialogTitle id="alert-dialog-title" disableTypography style={{fontSize:'18px'}}> 

            {userType == 'claimant' && (this.context.t('The Respondent proposes')  +separator+ this.props.respondentArbitratorName)+separator} 
            {userType == 'respondent' && this.context.t('The Claimant proposes') +separator+ this.props.claimantArbitratorName+separator} 
            
            {userType == 'claimant' && this.context.t('to be the Arbitrator, will the Claimant accept or reject this proposal?')} 

            {userType == 'respondent'  && this.context.t('to be the Arbitrator, will the Respondent accept or reject this proposal?')}
            {/* , {arbitratorLastName}  {arbitratorFirstName}? */}
            
              {/* {this.context.t('The Claimant proposes')}{this.props.claimantArbitratorName}{this.context.t('as the Arbitrator; do you accept or not?')} */}
            </DialogTitle>
            
            <DialogActions>
              
              <Button disableTypography  style={{textTransform: 'none',fontSize:'18px'}} onClick={() => this.handleClose('Upload_Yes')} color="primary" autoFocus>
                {this.context.t('Accept')}
              </Button>
              
              <Button disableTypography  style={{textTransform: 'none',fontSize:'18px'}} onClick={() => this.handleClose('Upload_No')} color="primary">
              {this.context.t('Reject')}
              </Button>
              
            </DialogActions>
          </Dialog>
        </div>
      );
    
}
}
ChooseArbitratorDialogInCaseInformation.contextTypes = {
  t: PropTypes.func
}
export default withStyles(styles)(ChooseArbitratorDialogInCaseInformation);